/* LimLux P0 — luxurious hero scroll (sticky fade/scale + subtle parallax). Copy theme only. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function scrubInnerCircle() {
    try {
      var re = /inner\s*circle|⚜️/i;
      var nodes = document.querySelectorAll('h1,h2,h3,h4,h5,p,a,span,li,button,label');
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
        if (!t || t.length > 80) continue;
        if (!re.test(t)) continue;
        if (/^[\s⚜️]*inner\s*circle[\s⚜️]*$/i.test(t) || (/^⚜️/.test(t) && /inner\s*circle/i.test(t))) {
          var block = el.closest('.text-block, .menu-list__list-item, li, .newsletter, .rte-formatter, rte-formatter') || el;
          block.style.setProperty('display', 'none', 'important');
          block.setAttribute('hidden', '');
          block.setAttribute('data-ll-scrubbed', 'inner-circle');
        }
      }
      document.querySelectorAll('a[href*="inner-circle"], a[href*="join-the-limlux"]').forEach(function (a) {
        a.style.setProperty('display', 'none', 'important');
        a.setAttribute('hidden', '');
      });
    } catch (e) {}
  }

  function initHeroMotion() {
    var section = document.querySelector('.shopify-section[id*="hero_xXWhRy"]');
    if (!section) return;
    var video = section.querySelector('video');
    var content = section.querySelector('.hero__content-wrapper, .hero__content, [class*="content-wrapper"]');
    section.classList.add('ll-hero-motion');
    if (reduce) {
      section.classList.add('ll-hero-motion--reduced');
      return;
    }
    // Capture document Y once at rest — sticky rewrites offsetTop while pinned
    var naturalTop = section.getBoundingClientRect().top + window.scrollY;
    var naturalH = Math.max(section.offsetHeight, window.innerHeight || 1);
    section.dataset.llNaturalTop = String(naturalTop);
    var ticking = false;
    function update() {
      ticking = false;
      var progress = Math.min(1, Math.max(0, (window.scrollY - naturalTop) / naturalH));
      var parallax = progress * 22;
      var scale = 1 - progress * 0.08;
      var fade = 1 - progress * 0.55;
      if (video) {
        video.style.transform = 'translate3d(0, ' + parallax + '%, 0) scale(' + scale + ')';
        video.style.opacity = String(Math.max(0.4, fade));
      }
      if (content) {
        content.style.opacity = String(Math.max(0, 1 - progress * 1.35));
        content.style.transform = 'translate3d(0, ' + (progress * -18) + 'px, 0)';
      }
      section.style.setProperty('--ll-hero-progress', progress.toFixed(3));
    }
    function onScroll() {
      if (!ticking) {
        ticking = true;
        window.requestAnimationFrame(update);
      }
    }
    update();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () {
      naturalTop = parseFloat(section.dataset.llNaturalTop || '0');
      // On resize from scrollY~0 only remeasure; keep first-paint top otherwise
      if (window.scrollY < 8) {
        naturalTop = section.getBoundingClientRect().top + window.scrollY;
        naturalH = Math.max(section.offsetHeight, window.innerHeight || 1);
        section.dataset.llNaturalTop = String(naturalTop);
      }
      onScroll();
    }, { passive: true });
  }

  function boot() {
    scrubInnerCircle();
    initHeroMotion();
    setTimeout(scrubInnerCircle, 1200);
    setTimeout(scrubInnerCircle, 3500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
